import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: '我們使用 Cookie',
    description: '我們使用 Cookie 和類似技術來提供此體驗。嚴格必要的 Cookie 一律處於啟用狀態。',
    allow_label: '接受所有 Cookie',
    reject_label: '僅限嚴格必要的 Cookie',
    settings_label: 'Cookie 設定',
    policy_link_label: '隱私權與 Cookie 政策',
    categories_label: '類別',
    always_on_label: '一律啟用',
    required_label: '必要',
    save_preferences_label: '儲存偏好設定',
    close_label: '關閉',
    allow_all_optional_categories_label: '允許所有選用類別',
    save_error: '無法儲存您的隱私權選擇。請再試一次。'
  },
  categories: {
    strictly_necessary: {
      name: '嚴格必要',
      purpose: '提供此體驗所必需，且無法停用。'
    },
    analytics: { name: '分析', purpose: '衡量訪客如何使用此體驗，以改善效能。' },
    marketing: { name: '行銷', purpose: '支援主辦方選擇的廣告和行銷。' }
  }
};

export default locale;
